const RegisterFormSvg = () => {
  return (
    <svg
      width='462'
      height='380'
      viewBox='0 0 462 380'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M387.88 326L36.67 379.2C34.8152 379.487 32.9209 379.385 31.1074 378.902C29.2939 378.418 27.6006 377.563 26.1349 376.391C24.6692 375.218 23.463 373.754 22.5929 372.091C21.7227 370.428 21.2075 368.603 21.08 366.73L0.080007 50.43C-0.0639661 48.3724 0.235489 46.3078 0.958129 44.3758C1.68077 42.4439 2.80975 40.6896 4.26877 39.2315C5.72778 37.7734 7.48281 36.6456 9.41524 35.9242C11.3477 35.2028 13.4124 34.9047 15.47 35.05L367.3 57.5C370.531 57.695 373.585 59.0373 375.914 61.2851C378.242 63.5329 379.691 66.5384 380 69.76L400.16 310.62C400.383 314.25 399.251 317.833 396.982 320.675C394.713 323.517 391.469 325.414 387.88 326V326Z'
        fill='#63737A'
      />
      <path
        d='M397.44 325.58L44.56 379C42.7066 379.282 40.8148 379.177 39.0042 378.691C37.1936 378.205 35.5037 377.348 34.0412 376.175C32.5787 375.002 31.3756 373.538 30.5078 371.876C29.6401 370.214 29.1267 368.391 29 366.52L7.78001 48.7701C7.63645 46.6857 7.94129 44.5949 8.67399 42.6383C9.40669 40.6817 10.5502 38.9049 12.0276 37.4276C13.5049 35.9503 15.2817 34.8067 17.2382 34.074C19.1948 33.3413 21.2857 33.0365 23.37 33.1801L376.65 55.6301C379.908 55.8402 382.983 57.2157 385.311 59.5053C387.639 61.7948 389.065 64.8455 389.33 68.1001L409.7 310C410.102 313.685 409.044 317.381 406.751 320.294C404.459 323.207 401.116 325.105 397.44 325.58Z'
        fill='#22272E'
      />
      <path
        d='M167.38 216.69L68.05 222.09C66.5431 222.151 65.0722 221.62 63.9512 220.611C62.8302 219.602 62.1479 218.195 62.05 216.69L56.23 132.69C56.1911 131.902 56.3105 131.113 56.5813 130.372C56.852 129.63 57.2686 128.95 57.8065 128.372C58.3443 127.794 58.9925 127.33 59.7128 127.007C60.433 126.683 61.2107 126.508 62 126.49L161.34 127.12C162.82 127.094 164.252 127.642 165.337 128.649C166.422 129.655 167.075 131.043 167.16 132.52L173 210.45C173.051 211.231 172.946 212.015 172.689 212.754C172.433 213.494 172.031 214.174 171.507 214.756C170.983 215.338 170.348 215.809 169.639 216.141C168.93 216.473 168.162 216.66 167.38 216.69V216.69Z'
        fill='#12A2DC'
      />
      <path
        d='M274.2 184.27L191.07 187.18C189.561 187.241 188.089 186.708 186.968 185.697C185.847 184.686 185.165 183.277 185.07 181.77L181.53 133.35C181.487 132.555 181.605 131.759 181.877 131.011C182.149 130.263 182.569 129.577 183.113 128.995C183.656 128.413 184.312 127.947 185.04 127.625C185.768 127.303 186.554 127.131 187.35 127.12L270.48 127.74C271.941 127.777 273.339 128.345 274.411 129.34C275.483 130.334 276.154 131.685 276.3 133.14L279.81 178C279.883 178.786 279.793 179.579 279.546 180.329C279.298 181.079 278.899 181.77 278.372 182.358C277.846 182.947 277.203 183.42 276.486 183.749C275.768 184.078 274.99 184.256 274.2 184.27V184.27Z'
        fill='#FFE779'
      />
      <path
        d='M368.34 181.15L298.34 183.64C296.832 183.703 295.36 183.173 294.239 182.164C293.117 181.154 292.435 179.746 292.34 178.24L288.81 134.39C288.765 133.595 288.882 132.798 289.154 132.049C289.425 131.3 289.846 130.614 290.389 130.032C290.933 129.45 291.589 128.984 292.318 128.662C293.047 128.34 293.833 128.17 294.63 128.16L364.63 128.57C366.093 128.607 367.492 129.177 368.564 130.174C369.636 131.17 370.307 132.524 370.45 133.98L373.77 174.91C373.847 175.681 373.765 176.46 373.53 177.198C373.295 177.936 372.912 178.618 372.403 179.203C371.894 179.787 371.272 180.262 370.573 180.597C369.874 180.931 369.114 181.12 368.34 181.15V181.15Z'
        fill='#F4C2C9'
      />
      <path
        d='M173.62 298.15L74.28 309C73.4972 309.094 72.7033 309.027 71.9476 308.802C71.1919 308.577 70.4905 308.199 69.8868 307.692C69.2831 307.184 68.7899 306.559 68.4378 305.853C68.0857 305.148 67.8823 304.377 67.84 303.59L64.1 249.31C64.0337 247.778 64.5563 246.279 65.5605 245.121C66.5647 243.962 67.9744 243.232 69.5 243.08L169.05 236.43C169.814 236.374 170.581 236.47 171.308 236.711C172.035 236.953 172.707 237.335 173.286 237.837C173.865 238.338 174.339 238.949 174.681 239.635C175.023 240.32 175.227 241.066 175.28 241.83L179 291.92C179.004 293.432 178.461 294.895 177.473 296.039C176.485 297.184 175.117 297.933 173.62 298.15V298.15Z'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M283.55 296.07L200.63 305.84C199.848 305.934 199.055 305.867 198.3 305.643C197.545 305.418 196.844 305.041 196.24 304.535C195.637 304.029 195.143 303.404 194.791 302.7C194.438 301.996 194.234 301.227 194.19 300.44L187.54 210.87C187.43 209.327 187.937 207.803 188.949 206.633C189.962 205.463 191.397 204.743 192.94 204.63L276.07 200.68C277.579 200.62 279.051 201.152 280.172 202.163C281.293 203.174 281.975 204.583 282.07 206.09L288.72 289.84C288.81 291.341 288.327 292.82 287.366 293.977C286.406 295.134 285.042 295.882 283.55 296.07V296.07Z'
        fill='#F4C2C9'
      />
      <path
        d='M266.3 216.27L206.66 219.8C206.323 219.798 205.989 219.87 205.682 220.011C205.375 220.152 205.103 220.358 204.885 220.616C204.667 220.873 204.508 221.175 204.419 221.501C204.33 221.826 204.313 222.167 204.37 222.5L207.08 259.5C207.092 259.832 207.174 260.159 207.32 260.458C207.466 260.757 207.672 261.022 207.926 261.236C208.18 261.451 208.477 261.61 208.796 261.704C209.115 261.797 209.45 261.823 209.78 261.78L269.42 256.59C269.752 256.576 270.078 256.493 270.377 256.347C270.675 256.201 270.941 255.995 271.156 255.741C271.371 255.487 271.531 255.192 271.626 254.874C271.722 254.555 271.75 254.22 271.71 253.89L269 218.56C268.868 217.933 268.53 217.368 268.042 216.953C267.553 216.539 266.94 216.298 266.3 216.27V216.27Z'
        fill='#12A2DC'
      />
      <path
        d='M376.65 275.5L306.65 283.19C305.867 283.286 305.072 283.219 304.316 282.995C303.56 282.77 302.858 282.393 302.254 281.885C301.65 281.378 301.157 280.751 300.805 280.045C300.453 279.339 300.251 278.568 300.21 277.78L294.6 205.67C294.49 204.128 294.997 202.605 296.01 201.437C297.022 200.268 298.458 199.55 300 199.44L370 196.11C371.509 196.05 372.981 196.582 374.102 197.593C375.223 198.604 375.905 200.013 376 201.52L381.61 269.26C381.696 269.996 381.636 270.741 381.433 271.454C381.23 272.166 380.889 272.832 380.428 273.412C379.967 273.991 379.396 274.475 378.747 274.833C378.099 275.191 377.386 275.418 376.65 275.5V275.5Z'
        fill='#FFE779'
      />
      <path
        d='M122.91 263.86L124.16 279.24'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M116.26 272.17L130.81 270.93'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M222.45 280.9C222.04 276.74 218.92 273.42 215.18 273.84C211.44 274.26 208.53 277.99 208.95 282.36C209.37 286.73 212.69 289.84 216.43 289.42C220 288.8 222.66 285.06 222.45 280.9Z'
        fill='#282828'
      />
      <path
        d='M234.51 279.65L273.37 275.71'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M321 219C320.58 215.05 317.88 212.14 314.56 212.14C311.23 212.35 308.95 215.68 309.15 219.63C309.57 223.57 312.27 226.69 315.6 226.48C319.09 226.25 321.37 222.92 321 219Z'
        fill='#12A2DC'
      />
      <path
        d='M331.56 218.35L365.02 216.27'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M322.83 241.21C322.41 237.21 319.71 234.35 316.39 234.56C313.07 234.77 310.78 238.3 310.98 242.25C311.4 246.2 314.31 249.31 317.43 248.9C320.75 248.48 323.25 245.16 322.83 241.21Z'
        fill='#12A2DC'
      />
      <path
        d='M333.22 240.38L366.89 237.68'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M324.7 263.44C324.28 259.5 321.58 256.59 318.26 256.79C314.94 256.99 312.65 260.54 312.85 264.48C313.27 268.43 316.18 271.34 319.3 271.13C322.62 270.72 324.91 267.39 324.7 263.44Z'
        fill='#12A2DC'
      />
      <path
        d='M335.09 262.41L368.55 259.08'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M90.91 160.16L77.4 160.37C76.782 160.339 76.1942 160.093 75.7379 159.675C75.2816 159.257 74.9853 158.693 74.9 158.08L73.9 143.95C73.8859 143.619 73.9406 143.289 74.0607 142.981C74.1808 142.672 74.3637 142.392 74.5978 142.158C74.8319 141.924 75.1121 141.741 75.4206 141.621C75.7291 141.501 76.0592 141.446 76.39 141.46H89.9C90.5148 141.493 91.099 141.739 91.5531 142.154C92.0072 142.57 92.303 143.131 92.39 143.74L93.39 157.67C93.311 158.301 93.0246 158.888 92.5757 159.339C92.1268 159.79 91.5409 160.079 90.91 160.16V160.16Z'
        fill='#FFE779'
      />
      <path
        d='M105.45 141.46L152.21 141.25'
        stroke='#F5FEFF'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M106.29 153.51L153.04 153.09'
        stroke='#F5FEFF'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M315.14 156.83L304.54 157.04C304.205 156.993 303.891 156.852 303.634 156.632C303.377 156.412 303.188 156.124 303.09 155.8L302.09 142.29C302.085 142.098 302.118 141.906 302.189 141.727C302.26 141.548 302.366 141.386 302.502 141.249C302.637 141.113 302.799 141.005 302.978 140.933C303.156 140.861 303.348 140.826 303.54 140.83H314.14C314.476 140.88 314.791 141.024 315.05 141.245C315.308 141.466 315.499 141.756 315.6 142.08L316.6 155.38C316.574 155.758 316.412 156.113 316.143 156.38C315.874 156.647 315.518 156.807 315.14 156.83Z'
        fill='#282828'
      />
      <path
        d='M325.12 140.63H359.82'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M326.15 151.22L360.65 150.81'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M304.13 168.47L361.9 167.02'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M93.19 192.37L79.68 192.79C79.0535 192.79 78.45 192.554 77.9888 192.13C77.5277 191.706 77.2426 191.124 77.19 190.5L76.19 176.37C76.1711 176.055 76.2159 175.739 76.3218 175.442C76.4276 175.144 76.5923 174.871 76.8061 174.639C77.0198 174.406 77.2782 174.219 77.5658 174.089C77.8534 173.959 78.1643 173.888 78.48 173.88L91.99 173.46C92.6063 173.494 93.1917 173.74 93.6459 174.158C94.1002 174.576 94.3951 175.139 94.48 175.75L95.48 189.67C95.5196 190.328 95.3036 190.977 94.877 191.48C94.4503 191.983 93.846 192.302 93.19 192.37Z'
        fill='#FFE779'
      />
      <path
        d='M107.74 173.25L154.5 172.01'
        stroke='#F5FEFF'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M108.57 185.51L155.33 184.06'
        stroke='#F5FEFF'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M127.27 91.7901L57.27 89.7101C56.1568 89.6808 55.0941 89.2389 54.2884 88.4701C53.4827 87.7014 52.9915 86.6607 52.91 85.5501L52.08 74.5501C52.027 73.9269 52.1072 73.2995 52.3152 72.7097C52.5233 72.1199 52.8544 71.5811 53.2866 71.129C53.7188 70.6769 54.2422 70.322 54.8221 70.0877C55.402 69.8534 56.0251 69.7451 56.65 69.77L126.65 72.6801C127.759 72.7137 128.817 73.156 129.62 73.922C130.423 74.688 130.914 75.7237 131 76.8301L131.85 87.0001C131.884 87.6203 131.791 88.241 131.576 88.8238C131.36 89.4065 131.028 89.9388 130.598 90.3878C130.169 90.8368 129.652 91.1929 129.08 91.4341C128.507 91.6753 127.891 91.7965 127.27 91.7901V91.7901Z'
        fill='#12A2DC'
      />
      <path
        d='M198.14 141.04L264.23 140.83'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M198.97 152.68L265.06 151.85'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M200.22 170.97L235.75 170.14'
        stroke='#282828'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M366.26 90.75C366.06 87.63 363.77 84.93 361.07 84.75C358.57 84.55 356.5 87.25 356.91 90.36C357.12 93.69 359.41 96.36 362.11 96.36C364.6 96.57 366.47 93.87 366.26 90.75Z'
        fill='#63737A'
      />
      <path
        d='M347.77 90.13C347.56 86.8 345.07 84.13 342.57 84.13C339.87 83.92 338 86.62 338.21 89.95C338.42 93.28 340.91 95.95 343.61 95.95C346.1 95.94 348 93.24 347.77 90.13Z'
        fill='#63737A'
      />
      <path
        d='M328.65 89.29C328.44 85.97 325.95 83.29 323.25 83.06C320.55 82.83 318.47 85.55 318.67 88.88C318.87 92.21 321.37 94.88 324.08 95.11C327 95.32 328.86 92.62 328.65 89.29Z'
        fill='#63737A'
      />
      <path
        d='M450.64 118L358.37 116.34C356.565 116.343 354.828 115.656 353.514 114.42C352.199 113.184 351.407 111.491 351.3 109.69L343 8.00002C342.952 7.19954 343.074 6.39796 343.359 5.6482C343.643 4.89844 344.083 4.21756 344.65 3.65051C345.217 3.08347 345.898 2.64315 346.648 2.35864C347.398 2.07414 348.199 1.95191 349 2.00002L441.69 11.77C443.379 11.9309 444.956 12.6889 446.136 13.9078C447.316 15.1267 448.023 16.7266 448.13 18.42L456.24 111.73C456.33 112.519 456.253 113.318 456.012 114.074C455.772 114.831 455.374 115.528 454.845 116.12C454.317 116.712 453.669 117.186 452.944 117.51C452.219 117.834 451.434 118.001 450.64 118V118Z'
        fill='#F8AB5D'
      />
      <path
        d='M455.62 116.31L363.35 114.65C361.546 114.653 359.81 113.966 358.497 112.729C357.185 111.493 356.395 109.8 356.29 108L348 6.38003C347.952 5.57955 348.074 4.77797 348.359 4.02821C348.643 3.27845 349.083 2.59756 349.65 2.03052C350.217 1.46347 350.898 1.02316 351.648 0.738649C352.398 0.454141 353.199 0.331911 354 0.380029L446.69 10.15C448.38 10.3089 449.957 11.0663 451.138 12.2856C452.319 13.5049 453.025 15.1059 453.13 16.8L461.23 110.11C461.291 110.89 461.193 111.675 460.94 112.416C460.688 113.157 460.287 113.839 459.761 114.419C459.236 115 458.598 115.467 457.886 115.792C457.174 116.117 456.403 116.293 455.62 116.31V116.31Z'
        fill='#FFE779'
      />
      <path
        d='M388.29 19.26L437.13 23.83'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M389.12 29.2401L437.96 33.3901'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M390.99 52.1L440.04 55.42'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M391.82 61.86L440.66 64.77'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M393.9 84.9301L442.74 87.0101'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M394.73 94.7L443.57 96.36'
        stroke='#63737A'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M371.46 24.87L373.95 27.99L377.49 23.21'
        stroke='#6DAFA7'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M374.16 58.12L376.65 61.03L380.39 56.25'
        stroke='#6DAFA7'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M376.86 90.75L379.56 93.66L383.1 88.67'
        stroke='#6DAFA7'
        strokeWidth='3.74'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default RegisterFormSvg;
